var acc = document.getElementsByClassName("accordion");
var accordion_index;

for (accordion_index = 0; accordion_index < acc.length; accordion_index++) {
  acc[accordion_index].addEventListener("click", function () {
    var panel = this.nextElementSibling;

    if (this.classList.contains("active")) {
      panel.style.maxHeight = null;
      this.classList.remove("active");
      return;
    }

    for (i = 0; i < acc.length; i++) {
      acc[i].nextElementSibling.style.maxHeight = null;
      acc[i].classList.remove("active");
    }

    this.classList.toggle("active");

    if (this.classList.contains("active")) {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } else if (!this.classList.contains("active")) {
      panel.style.maxHeight = null;
    }
  });
}
